import React, { useState } from "react";
import gsap from "gsap";
import { Button } from "../ui/button";
import { Menu, X } from "lucide-react";
import { Link, useLocation } from "react-router";
import { ROUTES } from "@/constant/routes";
import NavLinks from "./Navbar";
import { AppButton } from "./AppButton";
import TopBanner from "../floating-elements/TopBanner";
import WelcomeModal from "./modals/WelcomeModal";
import Logo from "../logo/Logo";

const navLinks = [
  { href: "#home", label: "Home" },
  { href: "#services", label: "Services" },
  { href: "#portfolio", label: "Portfolio" },
  { href: "#testimonials", label: "Testimonials" },
  { href: "#contact", label: "Contact" },
];

const TheHeader = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const location = useLocation();
  const buttonRef = React.useRef(null);

  const isHome = location.pathname === "/";

  // Continuous breathing/pulse animation for the CTA button
  React.useEffect(() => {
    const ctx = gsap.context(() => {
      gsap.to(buttonRef.current, {
        scale: 1.1,
        boxShadow: "0 0 25px rgba(147, 51, 234, 0.8)", // Stronger purple glow
        repeat: -1,
        yoyo: true,
        duration: 1.0, // Faster pulse
        ease: "sine.inOut",
      });
    });

    return () => ctx.revert();
  }, []);

  // Close mobile menu on outside click
  React.useEffect(() => {
    const handleClickOutside = (event) => {
      if (isMenuOpen && !event.target.closest('nav')) {
        setIsMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isMenuOpen]);

  return (
    <header>
      <nav className="fixed top-0 z-[99] w-full border-b border-gray-200 bg-white/95 backdrop-blur-sm">
        <TopBanner />
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="flex h-16 items-center justify-between">
            {/* Logo */}
            <Link
              to={ROUTES.HOME}
              className=""
            >
              <Logo />
            </Link>

            {/* Desktop Nav */}
            <div className="hidden lg:flex lg:items-center md:space-x-4 xl:space-x-6">
              {isHome && <NavLinks links={navLinks} />}
              <AppButton ref={buttonRef} variant="gradient" onClick={() => setIsModalOpen(true)}>
                Get Free Quote
              </AppButton>
            </div>

            {/* Mobile Menu Button */}
            <div className="lg:hidden">
              <Button
                variant="ghost"
                size="sm"
                onClick={() => setIsMenuOpen((prev) => !prev)}
              >
                {isMenuOpen ? (
                  <X className="h-6 w-6" />
                ) : (
                  <Menu className="h-6 w-6" />
                )}
              </Button>
            </div>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="border-t bg-white lg:hidden">
            <div className="space-y-1 px-2 pt-2 pb-3 sm:px-3">
              {isHome && (
                <NavLinks
                  links={navLinks}
                  isMobile
                  onLinkClick={() => setIsMenuOpen(false)}
                />
              )}
              <AppButton variant="gradient" onClick={() => {
                setIsModalOpen(true);
                setIsMenuOpen(false);
              }}>
                Get Free Quote
              </AppButton>
            </div>
          </div>
        )}
      </nav>
      {/* Welcome Modal */}
      <WelcomeModal show={isModalOpen} onClose={() => setIsModalOpen(false)} onSubmit={() => setIsModalOpen(false)} />
    </header>
  );
};

export default TheHeader;
